import { useEffect, useRef, useState } from "react";
import * as yup from "yup";
import Common from "../../../helper/common";
import {
  BookingCancellationReasonTypeEnum,
  respEnum,
} from "../../../constants/appConstant";
import { Formik } from "formik";
import { Icon } from "@iconify/react";
import {
  FormikInput,
  FormikSearchSelect,
  FormikSelect,
  FormikSwitch,
} from "../../../components/formik-components";
import { Button } from "../../../components/ui/button";

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const FormikInitialValues = {

  reason:null,
  reason_type:null,
  is_other:false,
};
const formikValidation = yup.object({
});

const AddBookingCancellationReason = ({ id, onClose, open, setOpen }) => {
  const formikRef = useRef();
  const dialogRef = useRef();
  const navigate = useNavigate();
  const [isFormikInitialized, setIsFormikInitialized] = useState(false);

  
  useEffect(() => {
    setIsFormikInitialized(open);
  }, [open]);

  useEffect(() => {
    if (id) {
      getData();
    }
  }, [id]);

  const onSubmitData = async (d, action) => {

    if (!d.reason && !d.reason_type && !d.is_other ) {
         toast.error(`Please Insert Data First`);
         return;
       }

    let data = {
      ...d,
      id,
    };
  
    data.reason = data.reason;
    data.is_other=data.is_other;
    data.reason_type=data.reason_type;



    let response = await Common.ApiService.getInstance().request(
      "AddUpdateBookingCancellationReason",
      data,
      "POST"
    );

    action.setSubmitting(false);
    if (response.status === respEnum.Success) {
      onClose(response.data);
      setOpen(false);
      if (!onClose) {
        navigate("/app/bookingcancellationreasons", { replace: true });
      }
    }


    
  };

  const getData = async () => {
    debugger;
    let response = await Common.ApiService.getInstance().request(
      `GetBookingCancellationReason?id=${id}`
    );
    if (response.status === respEnum.Success && response.data.length > 0) {

      const item = response.data[0];


      if(formikRef.current){

        formikRef.current.setValues({
          ...item,
          
          reason:item.reason,
          reason_type:item.reason_type,
        });
      }
    }
  };
  

  return (
    <div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <Button
            size="sm"
            variant="primary"
            className="flex items-center gap-2"
          >
            <Icon icon="heroicons:plus-20-solid" className="h-4 w-4" />
            Add
          </Button>
        </DialogTrigger>
        <DialogContent ref={dialogRef}>
          <DialogHeader>
            <DialogTitle className="text-base font-medium ">
              {!id ? "Add" : "Update"} Cancellation Reason
            </DialogTitle>
          </DialogHeader>

          <div className="text-sm text-default-500  space-y-2 max-h-[450px] overflow-y-auto pr-2">
            <Formik
              innerRef={formikRef}
              onSubmit={onSubmitData}
              initialValues={FormikInitialValues}
              validationSchema={formikValidation}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {(formikProps) => (
                <div className="md:grid md:grid-cols-1 gap-6 mt-6 space-y-6 md:space-y-0">
                  <div className="col-span-1">
                    <div className="md:grid md:grid-cols-1  gap-6 mt-6 space-y-6 md:space-y-0">
                      <div className="flex flex-col gap-2">
                        <FormikInput
                          formikProps={formikProps}
                          name={"reason"}
                          label={"Reason"}
                          placeholder={"Enter Reason"}
                        />
                      </div>
                      <div className="flex flex-col gap-2">

                        <FormikSwitch
                         formikProps={formikProps}
                         name={"is_other"}
                         label={"Is Other"}
                        />
                      </div>

                     

                      <div className="flex flex-col gap-2">
                         <FormikSearchSelect
                          formikProps={formikProps}
                          name={"reason_type"}
                          placeholder={"Select"}
                          label={"Reason Type"}
                          data={[
                            ...Common.Utility.enumToArray(BookingCancellationReasonTypeEnum),
                          ]}
                        />
                      </div>

                    </div>
                  </div>
                </div>
              )}
            </Formik>
          </div>
          <DialogFooter className="mt-8 gap-2">
            <DialogClose asChild>
              <Button type="button" variant="outline">
                Close
              </Button>
            </DialogClose>

            {isFormikInitialized && formikRef.current && (
              <Button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  formikRef.current?.handleSubmit();
                }}
              >
                {formikRef.current.isSubmitting
                  ? "Saving..."
                  : !id
                  ? "Add"
                  : "Update"}
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default AddBookingCancellationReason;
